module.exports = __webpack_public_path__ + "static/media/intro.4af6b7ba.mp3";